import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCard } from '@angular/material/card';

@Component({
    selector: 'app-botones-icon-seccion',
    templateUrl: './botones-icon-seccion.component.html',
    styleUrls: ['./botones-icon-seccion.component.scss'],
    imports: [MatCard]
})
export class BotonesIconSeccionComponent {

  @Input() titulo!: string;
  @Input() icono!: string;
  @Input() iconoHover?: string;
  @Input() iconoSeleccionado?: string;
  @Input() permiso!: string;
  @Input() estatusPermitidos: string[] = [];
  @Input() estatusActual!: string;
  @Input() accion!: string;
  @Input() responsable!: number;
  @Input() causa!: number;
  @Input() serie!: string;
  @Input() seleccionado: boolean = false;

  @Output() eventosBotonesNav = new EventEmitter<{ nombre: string, valor: any }>();

  hover = false;
  tienePermiso = true; // simulado, puedes reemplazar con lógica real

  mostrarIcono(): boolean {
    return this.tienePermiso && this.estatusPermitidos.includes(this.estatusActual);
  }

  emitirEventosBotones() {
    if (this.botonHabilitado == false) return;
    this.eventosBotonesNav.emit({ nombre: this.accion, valor: true });
  }

  get iconoActual(): string {
    if (this.botonHabilitado == false && this.iconoSeleccionado) return this.iconoSeleccionado;
    if (this.seleccionado && this.icono) return this.icono;
    if (this.hover && this.iconoHover) return this.iconoHover;
    return this.icono;
  }

  get botonHabilitado(): boolean {
    if (['Pagos', 'Recuperaciones', 'Pagos/Rec'].includes(this.titulo)) {
      // Deshabilitar si causa es 3 o 6, o si la serie es nula
      if ([3, 6].includes(this.causa) || this.serie == null) return false;

      // Solo habilitado si responsable es 1 o 2
      return [1, 2].includes(this.responsable);
    }
    return true;
  }
}
